var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.storeMenu)?_c('div',{staticClass:"mobile-wrapper"},[_c('shop-header',{attrs:{"store-id":_vm.storeid}}),(!(_vm.isGift))?_c('div',{staticClass:"content-padding-double"}):_vm._e(),_c('div',{staticClass:"container-fluid mobile-menu-content"},[_c('ProductList',{attrs:{"menu":JSON.parse(JSON.stringify(_vm.storeMenu))}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }